export default "__VITE_ASSET__OhzZsLFM__"